<!-- 组件说明 -->
<template>
  <!-- nav导航模块 -->
  <div class="nav">
    <div class="con navcon">
      <div class="dropdown">
        <div class="dt c-pointer" @click="isShowNav">
          <img
            :src="require('@/assets/images/icon_classification.png')"
            alt=""
          />
          全部商品分类
        </div>
        <div class="dd" v-show="isShow">
          <ul class="ddul">
            <li
              v-for="(item, index) in sideList"
              :key="index"
              @mouseover="showGoodsList(index)"
              @mouseout="hideGoodsList"
              :class="[sideIndex == index ? 'sideActive' : '']"
              @click="toDetailPage(item.id, 'rootCategoryId')"
            >
              <span class="c-pointer">{{ item.name }}</span>

              <ul class="goodsList" ref="goodsList" v-show="sideIndex == index">
                <li v-for="(item, index) in item.childrens" :key="index">
                  <div
                    class="goods-title c-pointer"
                    @click.stop="toDetailPage(item.id, 'secondCategoryId')"
                  >
                    {{ item.name
                    }}<i
                      style="margin-left: 2px; font-size: 10px"
                      class="el-icon-arrow-right"
                    ></i>
                  </div>
                  <ul class="goods-con c-pointer">
                    <li
                      v-for="(i, index) in item.childrens"
                      :key="index"
                      @click.stop="toDetailPage(i.id, 'categoryId')"
                    >
                      {{ i.name }}
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
          <!-- 商品明细列表 -->
        </div>
      </div>
      <div class="navitems">
        <ul>
          <li
            v-for="(item, index) in navList"
            :key="index"
            @click="
              changeNav(
                item.type,
                index,
                item.isBlankTarget,
                item.content,
                item.id
              )
            "
          >
            <span
              :class="[activeIndex == index ? 'active' : '']"
              class="c-pointer"
            >
              <img v-if="item.icon" v-lazy="item.icon" alt="" />{{ item.name }}
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      isShow: false,
      activeIndex: 0, //当前nav栏激活项
      sideIndex: null, //侧边栏激活项
      icon: ""
    };
  },
  computed: {
    ...mapState("sessionData", ["navbar", "tree"]),
    sideList() {
      return this.tree;
    },
    navList() {
      const data = this.navbar.topNavigations || [];
      data.map((item, index) => {
        if (item.type == 10) {
          data[index].icon = require("@/assets/images/icon_offer.png");
        } else if (item.type == 11) {
          data[index].icon = require("@/assets/images/icon_coupons.png");
        } else if (item.type == 14) {
          data[index].icon = require("@/assets/images/icon_caigou.png");
        }
      });
      let navId = this.$route.query.navId;
      if (navId) {
        data.map((item, i) => {
          if (item.id == navId) {
            this.activeIndex = i;
          }
        });
      }
      return data.filter(
        it =>
          it.id != 12 &&
          it.id != 13 &&
          it.id != 9 &&
          it.id != 14 &&
          it.id != 21 &&
          it.id != 23
      );
    }
  },
  watch: {
    $route: {
      handler: function(t, f) {
        // this.getTopNavlist();
        if (t.name == "home") {
          this.activeIndex = 0;
          this.isShow = true;
        } else {
          this.isShow = false;
        }
        //console.log(t, "==========================");
      },
      immediate: true
    }
  },
  methods: {
    changeNav(type, index, isblank, content, navId) {
      if (type == 1) {
        // 商品详情
        if (isblank) {
          let routeData = this.$router.resolve({
            path: `/detail?goodsId=${content}&type=1`
          });
          window.open(routeData.href, "_blank");
        } else {
          this.$router.push({ path: `/detail?goodsId=${content}&type=1` });
        }
      } else if (type == 2) {
        if (isblank) {
          let routeData = this.$router.resolve({
            path: `/search?keyword=${content}&navId=${navId}`
          });
          window.open(routeData.href, "_blank");
        } else {
          this.$router.push({
            path: `/search?keyword=${content}&navId=${navId}`
          });
        }
      } else if (type == 3) {
        if (isblank) {
          let routeData = this.$router.resolve({
            path: ` /detail?goodsId=${content}&type=2&navId=${navId}`
          });
          window.open(routeData.href, "_blank");
        } else {
          this.$router.push({
            path: ` /detail?goodsId=${content}&type=2&navId=${navId}`
          });
        }
      } else if (type == 4) {
        if (isblank) {
          let routeData = this.$router.resolve({
            path: `/meal?navId=${navId}`
          });
          window.open(routeData.href, "_blank");
        } else {
          this.$router.push({ path: `/meal?navId=${navId}` });
        }
      } else if (type == 5) {
        if (isblank) {
          let routeData = this.$router.resolve({
            path: `/bargain?navId=${navId}`
          });
          window.open(routeData.href, "_blank");
        } else {
          this.$router.push({ path: `/bargain?navId=${navId}` });
        }
      } else if (type == 6) {
        if (isblank) {
          let routeData = this.$router.resolve({
            path: `/helpcenter?id=${content}&navId=${navId}`
          });
          window.open(routeData.href, "_blank");
        } else {
          this.$router.push({
            path: `/helpcenter?id=${content}&navId=${navId}`
          });
        }
      } else if (type == 7) {
        if (isblank) {
          let routeData = this.$router.resolve({
            path: `/home?navId=${navId}`
          });
          window.open(routeData.href, "_blank");
        } else {
          this.$router.push({ path: `/home?navId=${navId}` });
        }
      } else if (type == 8) {
        if (isblank) {
          let routeData = this.$router.resolve({
            path: `/search?brandId=${content}&navId=${navId}`
          });
          window.open(routeData.href, "_blank");
        } else {
          this.$router.push({
            path: `/search?brandId=${content}&navId=${navId}`
          });
        }
      } else if (type == 9) {
        if (isblank) {
          let routeData = this.$router.resolve({
            path: `/search?id=${content}&navId=${navId}`
          });
          window.open(routeData.href, "_blank");
        } else {
          this.$router.push({
            path: `/search?id=${content}&navId=${navId}`
          });
        }
      } else if (type == 10) {
        if (isblank) {
          let routeData = this.$router.resolve({
            path: `/bargain?navId=${navId}`
          });
          window.open(routeData.href, "_blank");
        } else {
          this.$router.push({ path: `/bargain?navId=${navId}` });
        }
      } else if (type == 11) {
        if (isblank) {
          let routeData = this.$router.resolve({
            path: `/getcoupon?navId=${navId}`
          });
          window.open(routeData.href, "_blank");
        } else {
          this.$router.push({ path: `/getcoupon?navId=${navId}` });
        }
      } else if (type == 12) {
        if (isblank) {
          let routeData = this.$router.resolve({
            path: `/activities?navId=${navId}`
          });
          window.open(routeData.href, "_blank");
        } else {
          this.$router.push({ path: `/activities?navId=${navId}` });
        }
      } else if (type == 13) {
        if (isblank) {
          let routeData = this.$router.resolve({
            path: `/subjectDetail?id=${content}&navId=${navId}`
          });
          window.open(routeData.href, "_blank");
        } else {
          this.$router.push({
            path: `/subjectDetail?id=${content}&navId=${navId}`
          });
        }
      } else if (type == 14) {
        if (isblank) {
          let routeData = this.$router.resolve({
            path: `/shoppingsquare?navId=${navId}`
          });
          window.open(routeData.href, "_blank");
        } else {
          this.$router.push({ path: `/shoppingsquare?navId=${navId}` });
        }
      } else if (type == 15) {
        if (isblank) {
          let routeData = this.$router.resolve({
            path: `/control?brandId=${content}&navId=${navId}&isControl=true`
          });
          window.open(routeData.href, "_blank");
        } else {
          this.$router.push({
            path: `/control?brandId=${content}&navId=${navId}&isControl=true`
          });
        }
      } else if (type == 16) {
        if (isblank) {
          let routeData = this.$router.resolve({
            path: "/download"
          });
          window.open(routeData.href, "_blank");
        } else {
          this.$router.push({
            name: "download"
          });
        }
      }
    },
    showGoodsList(i) {
      this.sideIndex = i;
    },
    hideGoodsList() {
      this.sideIndex = null;
    },
    isShowNav() {
      this.isShow = !this.isShow;
    },
    toDetailPage(id, node) {
      this.$router.push({
        path: "/search",
        query: {
          id,
          ...(node && { node })
        }
      });
    }
  },
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="scss" scoped>
// .con{
//   display: flex;
//   flex-wrap: nowrap;
// }
.navcon {
  display: flex;
}
.nav {
  height: 40px;
  border-bottom: 2px solid #fa5555;
  margin-top: 24px;
}
.nav .dropdown {
  float: left;
  width: 194px;
  height: 40px;
  background-color: #f43737;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  flex-shrink: 0;
}
.nav .navitems {
  float: left;
}
.dropdown .dt {
  width: 100%;
  height: 95%;
  color: #fff;

  line-height: 40px;
  font-size: 14px;
  img {
    margin: 0 12px 0 20px;
  }
}
.dropdown .dd {
  position: relative;
  /* display: none; */
  width: 194px;
  height: 450px;
  background-color: #4d4d4d;
  margin-top: 2px;
  padding: 20px 0 36px 0;
  z-index: 201;
  // box-shadow: 0 0 10px 10px #c8c8c8;
}
.dropdown .dd .ddul > li {
  height: 40px;
  line-height: 40px;
  padding-left: 20px;
  color: #fff;
}

.dropdown .dd .ddul > li a {
  font-size: 14px;
  color: #ffffff;
}

.sideActive {
  background-color: #fff;
  span {
    color: #505050 !important;
  }
}
.navitems {
  margin-left: 40px;
  ul {
    display: flex;
    flex-wrap: nowrap;
    li {
      flex-shrink: 0;
    }
  }
}
.navitems > ul > li {
  float: left;
  span {
    display: block;
    height: 39px;
    line-height: 40px;
    font-size: 14px;
    padding: 0 15px;
    margin-right: 40px;

    img {
      vertical-align: middle;
      margin-right: 6px;
      padding-bottom: 3px;
    }
  }
}

.active {
  color: #fa5555;
  border-bottom: 3px solid #fa5555;
  font-weight: bold;
}
.goodsList {
  position: absolute;
  left: 194px;
  top: 0;
  width: 820px;
  height: 450px;
  background-color: #ffffff;
  padding: 10px 40px 30px 34px;
  overflow-y: auto;
  z-index: 200;
  //display: none;
  > li {
    line-height: 20px;
  }
  .goods-title {
    color: #333333;
    font-size: 14px;
    margin: 20px 0 16px 0;
    font-weight: 600;
  }
  .goods-con {
    display: flex;
    flex-wrap: wrap;
    > li {
      font-size: 14px;
      color: #333;
      padding-right: 20px;
      line-height: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/main/home-nav.vue